import React from 'react';
import { Label } from '@/components/ui/label';
import { NumberInput } from '@/components/ui/number-input';
import { AnimatedFormError } from '@/components/form/AnimatedFormError';
import { CustomizedFieldIndicator } from '../../../form/CustomizedFieldIndicator';
import { useShortTurnConfig } from '../ShortTurnConfigForm';
import { fieldLabelClass, fieldDescriptionClass } from '@/components/config_forms/shared/surcharge/fieldStyles';
import { cn } from '@/lib/utils';

export const FixedDollarField: React.FC = () => {
  const { shortTurnFixedSurchargeAmountProps, shortTurnFixedSurchargeAmountError, customizedFields = {}, context = 'user' } = useShortTurnConfig();

  const labels = {
    user: {
      fixedSurchargeLabel: "Fixed Surcharge Amount",
      fixedSurchargeDescription: "Set a fixed dollar amount to add for short turn shifts"
    },
    client: {
      fixedSurchargeLabel: "Fixed Surcharge Amount",
      fixedSurchargeDescription: "Set a fixed dollar amount to add for short turn shifts for this client"
    }
  };

  const currentLabels = labels[context];

  return (
    <div className="w-full grid grid-cols-[minmax(0,1fr)_auto] gap-x-4 gap-y-1 items-center md:grid-cols-2 md:items-start md:gap-4">
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <Label htmlFor="fixedSurcharge" className={cn(fieldLabelClass, "cursor-pointer")}>{currentLabels.fixedSurchargeLabel}</Label>
          <CustomizedFieldIndicator isCustomized={customizedFields.short_turn_fixed_surcharge_amount} context={context} />
        </div>
        <p className={cn(fieldDescriptionClass, "mt-1 hidden md:block")}>
          {currentLabels.fixedSurchargeDescription}
        </p>
      </div>
      <div className="flex flex-col items-end md:items-end">
        <NumberInput
          id="fixedSurcharge"
          unit="$"
          unitPosition="left"
          min={0}
          step={1}
          size="xs"
          {...shortTurnFixedSurchargeAmountProps}
          placeholder="0"
          className="input-recessed"
        />
        <AnimatedFormError className="mt-1 w-full md:text-right">
          {shortTurnFixedSurchargeAmountError}
        </AnimatedFormError>
      </div>
      <p className={cn(fieldDescriptionClass, "col-span-2 md:hidden")}>
        {currentLabels.fixedSurchargeDescription}
      </p>
    </div>
  );
};
